import React, { useState } from "react";
import LineChart from "./LineChart";
import "./ResumContainer.css";

const ResumeContainer = () => {
  const mode = "resumen";

  // Extraer modelo desde la URL
  const params = new URLSearchParams(window.location.search);
  const modelo = params.get("modelo");

  // Datos agrupados por modelo
  const direccionData = {
    "798": ['direccion_1', 'direccion_2', 'direccion_3', 'direccion_4', 'direccion_5', 'direccion_6'],
    "798_LPP": ['direccion_1', 'direccion_2', 'direccion_3', 'direccion_4', 'direccion_5', 'direccion_6'],
    "960E": ['direccion_1', 'direccion_2'],
    "797B": ['direccion_1', 'direccion_2', 'direccion_3'],
    "797F": ['direccion_1', 'direccion_2', 'direccion_3'],
    "797B_LPP": ['direccion_1', 'direccion_2', 'direccion_3'],
    "793F": ['direccion_1', 'direccion_2', 'direccion_3'],
  };

  const frenoData = {
    "798": ['freno_1', 'freno_2', 'freno_3'],
    "798_LPP": ['freno_1', 'freno_2', 'freno_3'],
    "960E": ['freno_1', 'freno_2'],
    "797B": ['freno_1', 'freno_2'],
    "797F": ['freno_1', 'freno_2', 'freno_3', 'freno_4'],
    "797B_LPP": ['freno_1', 'freno_2'],
    "793F": ['freno_1', 'freno_2', 'freno_3'],
    "777": ['freno_1', 'freno_2', 'freno_3'],
    "777F": ['freno_1', 'freno_2', 'freno_3'],
    "777G": ['freno_1', 'freno_2', 'freno_3'],
    "EEAA": ['freno_1', 'freno_2'],
    "854K": ['freno_1', 'freno_2'],
    "24M": ['freno_1', 'freno_2'],
    "994F": ['freno_1', 'freno_2'],
    "988H": ['freno_1', 'freno_2'],
    "988G": ['freno_1', 'freno_2'],
  };

  const renderCharts = (dataArray, type) =>
    dataArray.map((value, i) => {
      const clase = type === "dir" ? "direccion-res" : "freno-res";
      return (
        <div className={`item ${clase}`} key={`${type}-${i}`}>
          <LineChart task={value} mode={mode} />
        </div>
      );
    });



     // ✅ ESTADO para mostrar u ocultar
  const [visible, setVisible] = useState(true);


  return (

  <div className="seccion-nitrogeno">
      <div className="seccion-nitrogeno-header">
        <button
          className="toggle-btn"
          onClick={() => setVisible(!visible)}
          title="Mostrar/Ocultar sección"
        >
          {visible ? " Ocultar −" : " Mostrar +"}
        </button>
      </div>

      
      <div className={`main-container-wrapper ${visible ? "" : "oculto"}`}>
  <div className="main-container">
    {direccionData[modelo] && renderCharts(direccionData[modelo], "dir")}
    {direccionData[modelo] && frenoData[modelo] && (
      <div style={{ flexBasis: "100%" }} />
    )}
    {frenoData[modelo] && renderCharts(frenoData[modelo], "fre")}
  </div>
</div>


    </div>
  );


  
};

export default ResumeContainer;
